export default __webpack_public_path__ + "static/sdg-12-3b103cf890d53d9d1fb570fd6861e6ab.png";